import React from "react";
import { Alert } from "react-bootstrap";

export default function ErrorAlert({ error, title = "Error" }) {
  if (!error) return null;
  const message = typeof error === "string" ? error : error.message;
  return (
    <Alert variant="danger">
      <div className="fw-bold mb-1">{title}</div>
      <div className="small">{message}</div>
    </Alert>
  );
}

